export const LoadingMessage = () => {
  return <div className="bg-gray-400 text-black mr-auto p-4 rounded-lg w-full animate-pulse">
    <p className="bg-gray-500 rounded w-full text-xs">&nbsp;</p>
    <p className="bg-gray-500 rounded w-full text-xs">&nbsp;</p>
    <p className="bg-gray-500 rounded w-full text-xs">&nbsp;</p>
    <p className="bg-gray-500 rounded w-full text-xs">&nbsp;</p>
    <p className="bg-gray-500 rounded w-full text-xs">&nbsp;</p>
    <p className="bg-gray-500 rounded w-full text-xs">&nbsp;</p>
    <p className="bg-gray-500 rounded w-full text-xs">&nbsp;</p>
    <p className="bg-gray-500 rounded w-full text-xs">&nbsp;</p>

    <div className="border border-gray-400 bg-gray-300 text-teal-800 mr-auto p-4 rounded-lg w-1/2 flex flex-col gap-2">
      <div className="flex flex-col gap-2">
        <h4 className="font-medium bg-teal-500 rounded text-sm">&nbsp;</h4>
        <div className="border border-gray-400 bg-gray-300 text-teal-800 mr-auto p-4 rounded-lg w-full flex flex-col gap-2">
          <p className="pl-2 flex flex-col gap-1 bg-teal-400 rounded text-xs">&nbsp;</p>
        </div>
      </div>
    </div>
  </div>
}